export const version = '2.11.2';
//# sourceMappingURL=version.js.map